import axios from 'axios'
import {config} from '../Config/config'

const alamatService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/alamat')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    addData : (data) => {
        const result = axios.post(config.apiUrl + '/alamat', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getById : (id) => {
        const result = axios.get(config.apiUrl + '/alamatById/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    EditData : (data) => {
        const result = axios.put(config.apiUrl + '/alamat', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    DeleteData : (id) => {
        console.log(id)
        const result = axios.put(config.apiUrl + '/alamat_delete', id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getAllFilter : (filter) => {
        const result = axios.post(config.apiUrl + '/alamat_filter', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    countData : (filter) => {
        const result = axios.post(config.apiUrl + '/count_alamat', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    }
    
}


export default alamatService